import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { ErrorOutline } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "grey.100",
      }}
    >
      <Card sx={{ maxWidth: 400, width: "100%", mx: 2 }}>
        <CardContent sx={{ pt: 3 }}>
          <Box sx={{ display: "flex", mb: 2, gap: 1, alignItems: "center" }}>
            <ErrorOutline color="error" sx={{ fontSize: 32 }} />
            <Typography variant="h5" component="h1" fontWeight="bold">
              {t("notFound.title")}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            {t("notFound.body")}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
